<header></header>
<main>
  <section class="first-half">
    <div class="main-header">Welcome First Timer</div>
    <div class="second-header">Start Broadcasting Today</div>
    <div class="content"></div>
    <!-- <div class = "cubes cube-1"></div>
        <div class = "cubes cube-2"></div>
        <div class = "cubes cube-3"></div>
        <div class = "cubes cube-4"></div>
        <div class = "cubes cube-5"></div>
        <div class = "cubes cube-6"></div>
        <div class = "cubes cube-7"></div> -->
  </section>
  <section *ngIf="currentUser.canCreateChannels" class="second-half">
    <a [routerLink]="url">
      <div inlineSVG="/assets/icons/plus-sign.svg" class="plus-sign"></div>
    </a>
    <div class="content">Create Your First Channel</div>
  </section>
</main>
